import { useTranslation } from "react-i18next";
import PageHero from "@/components/layout/PageHero";
import { VisualSection } from "@/components/layout/visualLayout";
import Reveal from "@/components/common/Reveal";

export default function Imprint() {
  const { t } = useTranslation();

  const sections = [
    {
      id: "provider",
      title: "imprint.provider",
      lines: [
        "imprint.providerLine1",
        "imprint.providerLine2",
        "imprint.providerLine3",
        "imprint.providerLine4",
      ],
    },
    { id: "contact", title: "imprint.contact", isEmail: true },
    { id: "responsible", title: "imprint.responsibleTitle", line: "imprint.responsibleLine" },
    { id: "disclaimer", title: "imprint.disclaimerTitle", line: "imprint.disclaimer" },
  ];

  return (
    <div data-testid="page-imprint">
      <PageHero
        eyebrow={t("footer.imprint")}
        title={t("imprint.title")}
        testId="imprint-hero"
      />

      <VisualSection testId="imprint-content">
        <div className="grid gap-5 max-w-3xl" data-testid="imprint-sections">
          {sections.map((section, i) => (
            <Reveal key={section.id} delay={i * 0.07}>
              <article className="wit-card" data-testid={`imprint-${section.id}`}>
                <h2 className="wit-heading-card">{t(section.title)}</h2>
                {section.isEmail ? (
                  <a href={`mailto:${t("imprint.contactEmail")}`} className="text-raspberry hover:text-coral">
                    {t("imprint.contactEmail")}
                  </a>
                ) : section.lines ? (
                  <address className="not-italic">
                    {section.lines.map((key, j) => (
                      <p key={j} className={j === 0 ? "text-ink font-medium" : "text-warmGrey"}>
                        {t(key)}
                      </p>
                    ))}
                  </address>
                ) : (
                  <p className="wit-body">{t(section.line)}</p>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </VisualSection>
    </div>
  );
}
